module.exports = __webpack_public_path__ + "static/tools-resources-waye-day-photo@2x-fdb18abb71f058b1f05ce0da2da954d0.jpg";